<template>
  <v-row align="center" justify="center">
    <v-col cols="12" class="d-flex justify-center">
      <v-card style="width: 800px" shaped>
        <v-card-title>
          <v-icon large left color="primary">mdi-calendar-check</v-icon>
          <span class="title font-weight-light">Продажи за день</span>
        </v-card-title>
        <v-col>
          <v-expansion-panels flat>
            <v-expansion-panel>
              <v-expansion-panel-header>Немного об отчёте</v-expansion-panel-header>
              <v-expansion-panel-content>
                <p class="text-justify">
                  В современном понимании продажа считается неотъемлемой частью анализа продаж, служит
                  логическим продолжением, практическим результатом и подтверждением правильности ведущейся
                  маркетинговой работы компании. Отчёт показывает сумму продаж каждого филиала вашего
                  дистрибьютора за каждый день выбранного периода.
                </p>
                <p class="font-weight-medium mb-1">Шаги построения отчёта:</p>
                <ol class="mb-3">
                  <li>Задайте период — даты «с» и «по» включительно. Пусто — сегодня.</li>
                  <li>Выберите филиалы вашего дистрибьютора или оставьте поле пустым, чтобы взять все.</li>
                  <li>Нажмите «Сформировать отчёт» — файл Excel скачается автоматически.</li>
                </ol>
                <p class="text-justify mb-0">
                  Данные обновляются раз в сутки ночью: продажи за текущий день появятся в отчёте на следующий день.
                </p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-form ref="form">
          <v-col class="d-flex">
            <v-text-field
              class="mx-2"
              v-model="dateStart"
              label="Дата с... (включительно)"
              type="date"
              persistent-hint
              hint="Пусто — сегодня"
            ></v-text-field>
            <v-text-field
              class="mx-2"
              v-model="dateEnd"
              label="Дата по... (включительно)"
              type="date"
              persistent-hint
              hint="Пусто — как «Дата с»"
            ></v-text-field>
          </v-col>
          <v-col class="d-flex">
            <v-autocomplete
              class="mx-2"
              :label="filialsLabel"
              placeholder="Все филиалы"
              item-text="name"
              item-value="id"
              :items="options.filials"
              :loading="loading.options"
              v-model="filialIds"
              :rules="filialRules"
              multiple
              chips
              small-chips
              deletable-chips
              clearable
              persistent-hint
              :hint="filialsHint"
            ></v-autocomplete>
          </v-col>
          <v-col class="d-flex">
            <v-btn
              :loading="loading.download"
              @click="DownloadReport()"
              block
              color="primary"
            >
              Сформировать отчёт
              <template v-slot:loader>
                <span>Отчёт формируется...</span>
              </template>
            </v-btn>
          </v-col>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    dateStart: null,
    dateEnd: null,
    filialIds: [],
    options: {
      distributorName: null,
      filials: [],
      maxFilialCount: 20,
    },
    loading: {
      options: true,
      download: false,
    },
  }),
  computed: {
    filialsLabel() {
      return this.options.distributorName
        ? `Филиалы: ${this.options.distributorName}`
        : "Филиалы";
    },
    filialsHint() {
      return `Пусто — все филиалы; не больше ${this.options.maxFilialCount}`;
    },
    filialRules() {
      return [
        (value) =>
          !Array.isArray(value) ||
          value.length <= this.options.maxFilialCount ||
          `Выберите не более ${this.options.maxFilialCount} филиалов`,
      ];
    },
  },
  mounted() {
    this.GetFilterOptions();
  },
  methods: {
    async GetFilterOptions() {
      this.loading.options = true;
      try {
        this.options = await this.$store.dispatch("SALES_PER_DAY_REPORT_FILTER_OPTIONS");
      } catch (error) {
        window.console.log(error);
      } finally {
        this.loading.options = false;
      }
    },
    DownloadReport() {
      if (!this.$refs.form.validate()) {
        return;
      }

      const request = {
        dateStart: this.dateStart || null,
        dateEnd: this.dateEnd || null,
        filialIds: this.filialIds,
      };

      this.loading.download = true;
      this.$store
        .dispatch("DOWNLOAD_SALES_PER_DAY_REPORT", request)
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loading.download = false;
        });
    },
  },
};
</script>
